import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';
import {IS_ARCHIVED} from '@constants/staticDropdowns';

export const ArchivedFilter = ({
    loading = false,
    filters = {},
    filterKey,
    restoreFilterValues,
}) => {
    let isArchivedValue = restoreFilterValues(filters[filterKey], 'isArchived', 0);

    if ('' !== isArchivedValue) {
        isArchivedValue = isArchivedValue ? 1 : 0;
    }

    return (
        <Field
            component={Form.ReduxSelect}
            disabled={loading}
            loading={loading}
            name='isArchived'
            options={IS_ARCHIVED}
            setValue={isArchivedValue}
            placeholder='Archive status'
            selection
        />
    );
};

ArchivedFilter.propTypes = {
    loading: PropTypes.bool,
    filters: PropTypes.object,
    filterKey: PropTypes.string.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
